export default value => `${value.toFixed(2).toString().replace('.', ',')}%`
